import { ThinkPairShareGrow } from './Defaults/ThinkPairShareGrow';
import { JigsawMethod } from './Defaults/TheJigsawMethod';
import { ExperientialReflection } from './Defaults/ExperientialReflection.js';
import { LiteratureReflection } from './Defaults/LiteratureReflection.js';
import { ArgumentativeEssayPrep } from './Defaults/ArgumentativeEssayPrep.js';
import { CurrentEventsJournaling } from './Defaults/CurrentEventsJournaling.js';
import { CollaborativeExamPrep } from './Defaults/CollaborativeExamPrep.js';
import { LiteraryDevicesAndThemes } from './Defaults/LiteraryDevicesThemes.js';
import { ParlayWrittenTemplate } from './Defaults/ParlayWrittenTemplate';

export default [
  ParlayWrittenTemplate,
  ThinkPairShareGrow,
  JigsawMethod,
  ExperientialReflection,
  LiteratureReflection,
  ArgumentativeEssayPrep,
  CurrentEventsJournaling,
  CollaborativeExamPrep,
  LiteraryDevicesAndThemes,
];



// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Templates/Index.js